import {gql, useLazyQuery} from "@apollo/client";
import {useContext} from "react";
import {LocaleContext} from "../store/providers/LocaleProvider";
import {useLogger} from "./useLogger";
import {getBrowser} from "../common/common";

const QUERY = gql`
query getLegalPages ($locale: String!){
  companyDetailsCollection(limit: 1, locale: $locale){
    items {
      legalPagesCollection {
        items {
          pageTitle
          slug
          placeMonthYear
          availableInTheNavigation
          text {
            json
          }
          download {
            url
            size
          }
          company {
            companyName
          }
        }
      }
    }
  }
}`;

export const useLegalPagesLazy = () => {
    const {localeUppercase} = useContext(LocaleContext)[0];
    const {logger} = useLogger();
    const [getResults, { loading, data, error }] = useLazyQuery(QUERY, {
        variables: { locale: localeUppercase }
    }, {
        fetchPolicy: getBrowser() === "Safari" ? "network-only" : "cache-first",
        errorPolicy: "all"
    });

    const results = data?.companyDetailsCollection?.items[0]?.legalPagesCollection?.items?.filter(item => item.availableInTheNavigation);

    if (error?.message) {
        logger(error?.message, "error", "useLegalPagesLazy", error?.stack);
    }

    return {
        getLegalPages: getResults,
        legalPages: results,
        loadingLegalPages: loading,
        errorLegalPages: error
    };
};
